import Box from '@material-ui/core/Box';
import { makeStyles, Theme, useTheme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import withWidth, { WithWidth } from '@material-ui/core/withWidth';
import React from 'react';
import ROUTES from '../../routes';

import { useTranslation } from '../../hooks/useTranslation';
import colors from '../../themes/main-colors';
import NavPane from '../nav-pane';
import TextLink from '../text-link';
import Page2ColumnLayout from '../utility/page2-column-layout';

const useStyles = makeStyles((theme: Theme) => ({
  textPrimary: {
    color: colors.noirBlur,
  },
  footer: {
    textAlign: 'left',
    marginTop: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
    },
    '& > *:first-child': {
      marginBottom: theme.spacing(1),
    },
  },
}));

type Justify = 'left' | 'center';

interface AuthLayoutProps extends WithWidth {
  children: any;
  title?: string;
  subtitle?: string | React.ReactNode;
  justify?: Justify;
  footer?: any;
  includePrivacyAgreement?: boolean;
  showLeft?: boolean;
  sideNav?: any;
}

const AuthLayout = ({
  children,
  title,
  subtitle,
  footer,
  includePrivacyAgreement,
  showLeft = true,
  sideNav = <NavPane />,
}: AuthLayoutProps) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Page2ColumnLayout leftColumn={showLeft ? sideNav : undefined}>
      <Box>
        {title && (
          <Typography
            className={classes.textPrimary}
            variant={'h1'}
            color={'textPrimary'}
            gutterBottom
          >
            {title}
          </Typography>
        )}
        {subtitle && (
          <Typography
            className={classes.textPrimary}
            color={'textPrimary'}
            variant={'h4'}
          >
            {subtitle}
          </Typography>
        )}
        {children}
        {footer || (
          <Box className={classes.footer}>
            <Typography
              className={classes.textPrimary}
              style={{ marginTop: '1em' }}
              color={'textPrimary'}
              variant={'body1'}
            >
              {t('CALL_FOR_ASSISTANCE') + ' '}{' '}
              <TextLink
                external
                plain
                textColor={theme.palette.primary.main}
                to={`tel:${t('CALL_FOR_ASSISTANCE_NUMBER')}`}
              >
                {t('CALL_FOR_ASSISTANCE_NUMBER')}
              </TextLink>
            </Typography>
            {includePrivacyAgreement && (
              <Typography
                component={'span'}
                color={'textPrimary'}
                variant={'h4'}
              >
                {t('PRIVACY_AGREEMENT')}
                <TextLink
                  plain
                  textColor={theme.palette.primary.main}
                  to={ROUTES.PRIVACY_POLICY}
                >
                  {` ${t('PRIVACY_POLICY')}`}
                </TextLink>
                {'.'}
              </Typography>
            )}
          </Box>
        )}
      </Box>
    </Page2ColumnLayout>
  );
};

export default withWidth()(AuthLayout);
